/*
  Area IDs are structured in a hierarchy so we can figure its parent area from the ID
  EnterpriseID = {enterpriseID}
  LocationID = {enterpriseID}-{marketID}-{locationID}
  ZoneID = {enterpriseID}-{marketID}-{locationID}-{lotID}-{zoneID}
*/

export type AreaHierarchyIDsArgs =
  | { enterpriseID: string }
  | {
      marketID: string
    }
  | {
      locationID: string
    }
  | {
      lotID: string
    }
  | {
      zoneID: string
    }

export type EnterpriseResult = {
  enterpriseID: string
}
export type MarketResult = EnterpriseResult & {
  marketID: string
}
export type LocationResult = MarketResult & {
  locationID: string
}
export type LotResult = LocationResult & {
  lotID: string
}
export type ZoneResult = LotResult & {
  zoneID: string
}

export function getAreaHierarchyIDs(args: {
  enterpriseID: string
}): EnterpriseResult
export function getAreaHierarchyIDs(args: { marketID: string }): MarketResult
export function getAreaHierarchyIDs(args: {
  locationID: string
}): LocationResult
export function getAreaHierarchyIDs(args: { lotID: string }): LotResult
export function getAreaHierarchyIDs(args: { zoneID: string }): ZoneResult
export function getAreaHierarchyIDs(
  args: AreaHierarchyIDsArgs
): EnterpriseResult | MarketResult | LocationResult | LotResult | ZoneResult

export function getAreaHierarchyIDs(args: AreaHierarchyIDsArgs) {
  if ("enterpriseID" in args) {
    const parts = args.enterpriseID.split("-")
    return { enterpriseID: parts[0] }
  } else if ("marketID" in args) {
    const parts = args.marketID.split("-")
    return {
      enterpriseID: parts[0],
      marketID: `${parts[0]}-${parts[1]}`,
    }
  } else if ("locationID" in args) {
    const parts = args.locationID.split("-")
    return {
      enterpriseID: parts[0],
      marketID: `${parts[0]}-${parts[1]}`,
      locationID: `${parts[0]}-${parts[1]}-${parts[2]}`,
    }
  } else if ("lotID" in args) {
    const parts = args.lotID.split("-")
    return {
      enterpriseID: parts[0],
      marketID: `${parts[0]}-${parts[1]}`,
      locationID: `${parts[0]}-${parts[1]}-${parts[2]}`,
      lotID: `${parts[0]}-${parts[1]}-${parts[2]}-${parts[3]}`,
    }
  } else {
    const parts = args.zoneID.split("-")
    return {
      enterpriseID: parts[0],
      marketID: `${parts[0]}-${parts[1]}`,
      locationID: `${parts[0]}-${parts[1]}-${parts[2]}`,
      lotID: `${parts[0]}-${parts[1]}-${parts[2]}-${parts[3]}`,
      zoneID: `${parts[0]}-${parts[1]}-${parts[2]}-${parts[3]}-${parts[4]}`,
    }
  }
}
